import { render, staticRenderFns } from "./ClockInReminderModal.vue?vue&type=template&id=23be4202&"
import script from "./ClockInReminderModal.vue?vue&type=script&lang=js&"
export * from "./ClockInReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./ClockInReminderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports